const o = Symbol("FormInputsKey"), p = Symbol("FormGroupInputsKey");
export {
  p as FormGroupInputsKey,
  o as FormInputsKey
};
